import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Rocks } from "models/rocks";
import { RocksStatus } from "models/rocks-status";

export interface RocksSliceState {
    rocks: Rocks[],
    rocksStatus: RocksStatus[],
    rocksCount: number,
    isLoadingRocks: boolean
    isDeletingRocks: boolean
}

export const initialState: RocksSliceState = {
    rocks: [],
    rocksStatus: [],
    rocksCount: 0,
    isLoadingRocks: true, 
    isDeletingRocks: false
};

const RocksSliceState = createSlice({
    name: "rocks-slice",
    initialState,
    reducers: {
        setRocks(state, { payload }: PayloadAction<Rocks[]>) {
            state.rocks = payload
        },
        setRocksCount(state, { payload }: PayloadAction<number>) {
            state.rocksCount = payload
        },
        setIsRocksLoading(state, { payload }: PayloadAction<boolean>) {
            state.isLoadingRocks = payload
        },
        setRocksSearchFields(state, { payload }: PayloadAction<{
            rocksStatus: RocksStatus[]
        }>) {
            state.rocksStatus = payload.rocksStatus
        },
        setRock(state, { payload }: PayloadAction<{
            rock: Rocks,
            index: number
        }>) {
            state.rocks[payload.index] = payload.rock
        },
        deleteRock(state, { payload: rockId }: PayloadAction<string>) {
            state.rocks = state.rocks.filter(r => r.id !== rockId);
            state.rocksCount = state.rocksCount - 1
        }, 
        setIsDeletingRocks(state, {payload}: PayloadAction<boolean>) {
            state.isDeletingRocks = payload
        }
    },
});

export const {
    setRocks,
    setRocksCount,
    setIsRocksLoading,
    setRocksSearchFields,
    setRock, 
    deleteRock, 
    setIsDeletingRocks
} = RocksSliceState.actions

export default RocksSliceState.reducer;
